export const cardHeight = 120;
export const detailsSectionId = 'details';
